export default __webpack_public_path__ + "static/media/Paladino_Terminal_LE.7467d012.jpg";